import { Palette } from '@core/config/constants';

/** Una pregunta de la trivia con sus opciones y el indice de la respuesta correcta. */
export interface TriviaQuestion {
  readonly question: string;
  readonly options: readonly string[];
  readonly correctIndex: number;
}

/**
 * Banco de preguntas (genericas y aptas para 11-14 años, sin referencias a artistas
 * reales). Para agregar preguntas, sumar objetos a este arreglo.
 */
export const TRIVIA_QUESTIONS: readonly TriviaQuestion[] = [
  {
    question: '¿Cuántas notas tiene la escala musical básica (Do Re Mi...)?',
    options: ['5', '7', '8', '12'],
    correctIndex: 1,
  },
  {
    question: '¿Qué instrumento tiene teclas blancas y negras?',
    options: ['Guitarra', 'Piano', 'Batería', 'Violín'],
    correctIndex: 1,
  },
  {
    question: '¿Cómo se llama la secuencia de pasos de un baile?',
    options: ['Melodía', 'Coreografía', 'Armonía', 'Partitura'],
    correctIndex: 1,
  },
  {
    question: '¿Qué color se forma al mezclar azul y amarillo?',
    options: ['Verde', 'Naranja', 'Violeta', 'Marrón'],
    correctIndex: 0,
  },
  {
    question: '¿Cuántos integrantes tiene un quinteto?',
    options: ['3', '4', '5', '6'],
    correctIndex: 2,
  },
  {
    question: '¿Qué se usa para grabar o amplificar la voz?',
    options: ['Auriculares', 'Micrófono', 'Parlante', 'Trípode'],
    correctIndex: 1,
  },
  {
    question: 'La parte de una canción que se repite y es más pegadiza se llama...',
    options: ['Estrofa', 'Puente', 'Estribillo', 'Intro'],
    correctIndex: 2,
  },
  {
    question: '¿Qué marca la velocidad de una canción?',
    options: ['El tempo', 'El color', 'La letra', 'El título'],
    correctIndex: 0,
  },
];

/** Configuracion del minijuego de trivia. */
export const TriviaConfig = {
  key: 'TriviaScene',
  title: 'Trivia Musical',
  description: 'Responde preguntas de música, baile y mucho más.',
  icon: '🧠',
  color: Palette.highlight,

  /** Cantidad de preguntas por partida (se eligen al azar del banco). */
  questionsPerRound: 6,
  /** Puntos por respuesta correcta. */
  pointsPerCorrect: 20,
  /** Tiempo (ms) que se muestra el feedback antes de pasar a la siguiente. */
  feedbackDelayMs: 1100,
  /** Monedas otorgadas al finalizar por cada 100 puntos. */
  coinsPer100Points: 1,
} as const;
